module.exports = __webpack_public_path__ + "img/adv-icobg.ab0d3de3.svg";